const normalizeEvidenceRefs = (evidenceRefs) =>
  Array.isArray(evidenceRefs) ? evidenceRefs : [];

export const normalizeChatSuggestion = (suggestion) => {
  if (typeof suggestion === "string") {
    const question = suggestion.trim();
    return question ? { question, evidence_refs: [] } : null;
  }

  if (!suggestion || typeof suggestion !== "object" || Array.isArray(suggestion)) {
    return null;
  }

  const question =
    typeof suggestion.question === "string" ? suggestion.question.trim() : "";

  if (!question) return null;

  return {
    question,
    // Evidence references are opaque backend IDs. Preserve them verbatim.
    evidence_refs: normalizeEvidenceRefs(suggestion.evidence_refs),
  };
};

export const normalizeChatSuggestions = (suggestions) =>
  (Array.isArray(suggestions) ? suggestions : [])
    .map(normalizeChatSuggestion)
    .filter(Boolean);

export const getChatSuggestionsFromPayload = (payload) => {
  let parsedPayload = payload;

  if (typeof payload === "string") {
    try {
      parsedPayload = JSON.parse(payload);
    } catch {
      return [];
    }
  }

  if (!parsedPayload || typeof parsedPayload !== "object") return [];

  // `suggestions` is the legacy key. `questions` is the new API contract.
  return normalizeChatSuggestions(
    parsedPayload.questions ?? parsedPayload.suggestions,
  );
};
